module.exports = __webpack_public_path__ + "static/img/009_m.72bb098.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/module/009_m.png
// module id = m77j
// module chunks = 0